import React from "react";
import { BadgeWrapper } from "./styles";
import { BadgeProps } from "./types";

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = "default",
  style = "solid",
  size = "medium",
  icon,
  className,
  ...props
}) => {
  return (
    <BadgeWrapper
      $variant={variant}
      $style={style}
      $size={size}
      className={className}
      role="status"
      {...props}
    >
      {icon && <span className="badge-icon">{icon}</span>}
      <span className="badge-text">{children}</span>
    </BadgeWrapper>
  );
};
